import * as cart from '@shopify/theme-cart'
import { initialiseCarousel } from './../modules/_helpers'
import 'swiper/swiper.scss';
import axios from 'axios';

export default function init ({ el, context }) {
  const cartElement = document.querySelector('.push-cart')
  const cartTrigger = document.querySelector('[data-module-drawers-trigger="cart"]');
  const itemCount = document.querySelector('.item-count')

  const getCartHTML = async (lastItem) => {
    return await axios.get(`/cart?view=push-cart`)
  }

  const getCartState = async (lastItem) => {
    return await cart.getState()
  }

  const updateIcon = async () => {
    let cartState = await getCartState();
    let newCount = parseInt(cartState.item_count)
    itemCount.dataset.itemCount = newCount
    itemCount.innerText = newCount
  }

  const removeItem = async (key) => {
    return await cart.removeItem(key)
  }

  const buildCart = async () => {
    let cartHTML = await getCartHTML()
    cartElement.innerHTML = cartHTML.data
    addHandlers();
    initSwiper();
    updateIcon();
  }

  document.addEventListener('addedToCart', async (event) => {
    buildCart()
    setTimeout(function() {
      cartTrigger.click();
    }, 200);
    
  })

  const addHandlers = async () => {
    let cartSubmit = cartElement.querySelector('input.checkout')
    if(cartSubmit !== null){
      cartSubmit.addEventListener('click', (event) => {  

        
      });
    }
    

    let cartCloseTrigger = cartElement.querySelector('.push-cart__close')
    if(cartCloseTrigger === null){
      return;
    }
    cartCloseTrigger.addEventListener('click', (event) => {  
      event.preventDefault();
      cartTrigger.click();
    });

    let quantityAdjusters = cartElement.querySelectorAll('.push-cart__items__item__content__middle__quantity-adjuster')

    for (var i = quantityAdjusters.length - 1; i >= 0; i--) {
      quantityAdjusters[i].addEventListener('click', async (event) => {  
        event.preventDefault();
        
        let thisElement = event.currentTarget
        let thisQuantityElement = thisElement.parentElement.children[1]
        let currentQuantity = parseInt(thisQuantityElement.value)
        let adjustment
        let cartState = await cart.getState();
        if(thisElement.dataset.direction === 'down'){
          adjustment = currentQuantity - 1
        } else {
          adjustment = currentQuantity + 1
        }
        if(adjustment > 0){
          let changeQtyResult = await changeQty(thisQuantityElement, adjustment);
          if(changeQtyResult.item_count !== cartState.item_count){
            buildCart();
            addHandlers();
          } else {
            let middle = cartElement.querySelector('.push-cart__items__item__content__middle')
            let errorDiv = cartElement.createElement('div')
            errorDiv.innerHTML = `<span>Only ${currentQuantity} available</span>`
            errorDiv.classList.add('push-cart__items__item__error')
            middle.prepend(errorDiv)
            let error = middle.querySelector('.push-cart__items__item__error')
            setTimeout(function() {
              error.remove();
            }, 4000);
          }
        }
      });
    }
    let itemRemove = cartElement.querySelectorAll('.push-cart__items__item__content__middle__remove-button')
    for (var i = itemRemove.length - 1; i >= 0; i--) {
      itemRemove[i].addEventListener('click', async (event) => {  
        event.preventDefault();
        let key = event.currentTarget.dataset.key
        let result = await removeItem(key)
        buildCart();

      });
    }
    return true
  }

  const changeQty = async (thisQuantityElement, quantity) => {
    return await cart.updateItem(thisQuantityElement.dataset.key, { quantity })
  }

  const initSwiper = async () => {
    let swiper = cartElement.querySelector(`.push-cart__recommended__slider`)
    let swiperPrev = cartElement.querySelector(`.swiper-button-prev`)
    let swiperNext = cartElement.querySelector(`.swiper-button-next`)
    initialiseCarousel(
      swiper,
      {
        speed: 500,
        initialSlide: 0,
        observer: true,
        observeParents: true,
        spaceBetween: 10,
        slidesPerGroup: 1,
        slidesPerView: 2,
        grabCursor: true,
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrev,
        },
        breakpoints: {
          500: {
            slidesPerView: 3,
            slidesPerGroup: 1
          },
        }
      }
    )
  }

  initSwiper()
  addHandlers()
}